import { render, staticRenderFns } from "./WizardDelivery.vue?vue&type=template&id=8fd033a4&"
import script from "./WizardDelivery.vue?vue&type=script&lang=js&"
export * from "./WizardDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports